import { createSlice } from "@reduxjs/toolkit"

export const initialStationFilter = {
    modalFilter: {
        open: {
            stationStatus: false,
            state: false,
            city: false,
            zone:false,
            accessType: false,
            cobrandedId: false,
            state_office: false,
            territory_id:false
        },
        values: {
            stationStatus: "",
            state: "",
            city: null,
            zone:"",
            accessType: "",
            cobrandedId: "",
            state_office:"",
            territory_id:""
        },
    },
    quickFilter: {
        country: "",
        station_name: "",
        site_id: "",
        cpo: "",
        emsp: "",
        source: "",
    },
}

const stationSlice = createSlice({
    name: "station",
    initialState: {
        showColumns: [],
        activeFilters : initialStationFilter,
        selectedTab:""
    },
    reducers: {
        setShowColumns: (state, { payload: { columns } }) => {
            state.showColumns = columns
        },
        setActiveFilters :(state , {payload}) =>{
            state.activeFilters = payload
        },
          setSelectedTab: (state, { payload }) => {
            state.selectedTab = payload
        },
    },
})
export const { setShowColumns , setActiveFilters, setSelectedTab } = stationSlice.actions
export default stationSlice.reducer
